import { EmployeeRole } from '../../models/enums/employee-role.enum';

export type EmployeeRoleId = EmployeeRole | number | null | undefined;

export function isOwnerRole(roleId: EmployeeRoleId): boolean {
  return roleId === EmployeeRole.Owner;
}

export function isAdministratorRole(roleId: EmployeeRoleId): boolean {
  return roleId === EmployeeRole.Administrator;
}

export function isWorkerRole(roleId: EmployeeRoleId): boolean {
  return roleId === EmployeeRole.Employee;
}

export function getEmployeeRoleLabel(roleId: EmployeeRoleId): string {
  if (isOwnerRole(roleId)) {
    return 'Owner';
  }

  if (isAdministratorRole(roleId)) {
    return 'Administrator';
  }

  if (isWorkerRole(roleId)) {
    return 'Worker';
  }

  return 'Unknown';
}

export function getEmployeeRoleBadgeClass(roleId: EmployeeRoleId): string {
  if (isOwnerRole(roleId)) {
    return 'role-owner';
  }

  if (isAdministratorRole(roleId)) {
    return 'role-administrator';
  }

  if (isWorkerRole(roleId)) {
    return 'role-worker';
  }

  return 'role-unknown';
}

export function getEmployeeRoleOrder(roleId: EmployeeRoleId): number {
  if (isOwnerRole(roleId)) {
    return 1;
  }

  if (isAdministratorRole(roleId)) {
    return 2;
  }

  if (isWorkerRole(roleId)) {
    return 3;
  }

  return 99;
}

export function canAssignServicesToRole(roleId: EmployeeRoleId): boolean {
  return isOwnerRole(roleId) || isWorkerRole(roleId);
}